import React from "react";

import { Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { UserContext } from "../Routes";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      margin: theme.spacing(4, 0),
    },
  })
);

export default function WelcomeMessage() {
  const userDetails = React.useContext(UserContext);
  const classes = useStyles();
  return (
    <Typography variant="h4" className={classes.title}>
      Pozdrav, {userDetails?.user?.name}!
    </Typography>
  );
}
